import React, { useState } from 'react';
import { useToast } from '@chakra-ui/react';
import { UiKit, Button } from '@datavant/uikit';
import { EmrEnvironment } from '../../../../generated/tenant-api';
import { DigitalFulfillmentLogo } from '../../../../components/ProviderTools/DigitalFulfillmentLogo';
import useUser from '../../../../lib/useUser';
import { tRPCProxyClient } from '../../../../utils/trpc';

const EmrEnvironmentHelpText = {
    CLOUD: 'The system is accessed via URL/web browser.',
    ON_PREMISE: 'The system is accessed via a computer application.',
};

export const NotSureModal = (props: { isOpen: boolean; onClose: () => void }): JSX.Element => {
    const { user } = useUser();
    const [emrEnvironment, setEmrEnvironment] = useState<EmrEnvironment | undefined>(undefined);
    const toast = useToast();

    const onSubmit = async (): Promise<void> => {
        if (user?.tenantUUID) {
            await tRPCProxyClient.tenant.patchOwnTenant.mutate({
                isLiveDigitalFulfillment: false,
                emrEnvironment: emrEnvironment,
            });
        }
        toast({
            title: 'EMR environment submitted successfully!',
            status: 'success',
            duration: 2000,
            isClosable: true,
        });
        // Do not call onClose here, we want other next steps modal component to populate
    };

    const modalBody = (
        <UiKit.Chakra.VStack align={'stretch'} spacing={UiKit.consistency.buffer}>
            <UiKit.Chakra.VStack align={'center'} textAlign={'center'}>
                <DigitalFulfillmentLogo />
                <UiKit.Text.Heading2 text="What is your EMR Environment?" />
                <UiKit.Text.BodyRegular>
                    To move forward with Autofulfill setup, we will need to confirm how your EMR system is
                    hosted.
                </UiKit.Text.BodyRegular>
            </UiKit.Chakra.VStack>

            <>
                <UiKit.Form.RadioGroup
                    value={emrEnvironment}
                    onChange={val => {
                        setEmrEnvironment(val as EmrEnvironment);
                    }}
                    options={[
                        {
                            value: EmrEnvironment.CLOUD,
                            text: 'CLOUD',
                            helpText: EmrEnvironmentHelpText[EmrEnvironment.CLOUD],
                        },
                        {
                            value: EmrEnvironment.ON_PREMISE,
                            text: 'ON PREMISE',
                            helpText: EmrEnvironmentHelpText[EmrEnvironment.ON_PREMISE],
                        },
                    ]}
                />
            </>
            <UiKit.Text.BodyRegular>
                If you are unsure, please reach out to requestmanager@datavant.com to proceed.
            </UiKit.Text.BodyRegular>
        </UiKit.Chakra.VStack>
    );

    const modalFooter = (
        <UiKit.Chakra.HStack>
            <Button
                onClick={async () => {
                    await onSubmit();
                }}
                isDisabled={!emrEnvironment}
            >
                Submit
            </Button>
        </UiKit.Chakra.HStack>
    );

    return (
        <UiKit.Modal
            bodyFragment={modalBody}
            footerFragment={modalFooter}
            title="What is your EMR environment?"
            onClose={props.onClose}
            isOpen={props.isOpen}
            size="xl"
        />
    );
};
